// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1j7JN","buttons":"SendReceipts_buttons__1WHXJ","email":"SendReceipts_email__1x2GK","bookApptTitle":"SendReceipts_bookApptTitle__1Mr22"};